/**
 * Funzioni API per la soglia di hold della Batch Edit API (Admin — product-service).
 *
 * Endpoint:
 *   GET /api/products/admin/batch-edit-settings  → BatchEditSettings
 *   PUT /api/products/admin/batch-edit-settings  → BatchEditSettings (solo SYSTEM_CONFIGURATION)
 */
import { createServiceClient } from '../../api/client.js';

const productApi = createServiceClient('product');

/**
 * Soglia di hold: un run con N = nuovi + aggiornamenti + cancellazioni ≥ soglia va in attesa di
 * conferma (si esegue da solo solo con N < soglia).
 */
export interface BatchEditSettings {
  holdThreshold: number;
  /** admin = salvata da /admin; env = BATCH_EDIT_HOLD_THRESHOLD; default = 10. */
  source: 'admin' | 'env' | 'default';
  defaultHoldThreshold: number;
  min: number;
  max: number;
  rule: string;
  updatedAt?: string;
  updatedBy?: string;
}

export function fetchBatchEditSettings(): Promise<BatchEditSettings> {
  return productApi<BatchEditSettings>('/admin/batch-edit-settings');
}

export function updateBatchEditHoldThreshold(holdThreshold: number): Promise<BatchEditSettings> {
  return productApi<BatchEditSettings>('/admin/batch-edit-settings', {
    method: 'PUT',
    body: { holdThreshold },
  });
}
